import { PageLayout } from '../../PageLayout';
import { getCurrentUser } from '../../../store/User';
import { DashboardCharts } from './DashboardCharts';

export const Dashboard = () => {
  return (
    <PageLayout
      dataTestId="dashboard-page"
      pageTitle={`Welcome, ${getCurrentUser()?.firstName || ''} ${getCurrentUser()?.lastName || ''}`}>
      <DashboardCharts />
    </PageLayout>
  );
};
